import { render, staticRenderFns } from "./WorkspaceSettingsVerification.vue?vue&type=template&id=4fcea596&scoped=true"
import script from "./WorkspaceSettingsVerification.vue?vue&type=script&lang=js"
export * from "./WorkspaceSettingsVerification.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceSettingsVerification.vue?vue&type=style&index=0&id=4fcea596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcea596",
  null
  
)

export default component.exports